import { useConexaQuery } from '@/hooks/useConexaQuery'
import service from './theme.services'
import { cacheTime } from '@/constants/cacheTime/cacheTime'
import { useThemeGeneratorContext } from './contexts/ThemeGeneratorContext'
import { GeneralThemeAndControls, IThemeGeneratorContext } from './types'
import { setCache } from '@/utils/cache'

const sharedOnError = (
  setThemeColors: IThemeGeneratorContext['setThemeColors'],
) => {
  setThemeColors(null)
  setCache('unique-code', null)
  setCache('id-clinic', null)
}

const sharedOnSuccess = (
  theme: GeneralThemeAndControls,
  setThemeColors: IThemeGeneratorContext['setThemeColors'],
) => {
  if (!theme) {
    sharedOnError(setThemeColors)
    return
  }

  if (theme?.codigoUnicoClinica) {
    setCache('unique-code', String(theme.codigoUnicoClinica))
  }

  if (theme?.idClinic) {
    setCache('id-clinic', String(theme.idClinic))
  }

  setThemeColors(theme)
}

export const useGetClinicColorsByUniqueCode = (uniqueCode: string) => {
  const { setThemeColors } = useThemeGeneratorContext()

  return useConexaQuery({
    queryKey: ['clinic-colors-unique-code', uniqueCode],
    service: () => service.getClinicColorsByUniqueCode(uniqueCode),
    config: {
      enabled: !!uniqueCode,
      cacheTime: cacheTime.ONE_DAY,
      staleTime: cacheTime.ONE_DAY,
      retry: false,
      onSuccess: theme => {
        sharedOnSuccess(theme, setThemeColors)
      },
      onError: () => {
        sharedOnError(setThemeColors)
      },
    },
  })
}

export const useGetClinicColorsById = (id: number) => {
  const { setThemeColors } = useThemeGeneratorContext()

  return useConexaQuery({
    queryKey: ['clinic-colors-id', id],
    service: () => service.getClinicColorsById(id),
    config: {
      enabled: !!id,
      cacheTime: cacheTime.ONE_DAY,
      staleTime: cacheTime.ONE_DAY,
      retry: false,
      onSuccess: theme => {
        sharedOnSuccess(theme, setThemeColors)
      },
      onError: () => {
        sharedOnError(setThemeColors)
      },
    },
  })
}
